import {IGeoRestrictionsUpdateEventParams} from "../../sdk/sdk-events";
import {Check} from "@sparkware/app-utils";

export function isValidGeoKickEvent(kickParams: IGeoRestrictionsUpdateEventParams | undefined): kickParams is IGeoRestrictionsUpdateEventParams {
    if(Check.isNullOrUndefined(kickParams?.KickReasonId)) {
        return false;
    }

    return kickParams.KickReasonId.toString() !== "0";
}